import React, { useEffect } from 'react';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames/bind';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { StoreLayout } from '@thd-olt-component-react/store-layout';
import { StorePod } from '@thd-olt-component-react/store-pod';
import { StoreHeroFeatures } from './modules/store-hero-features/StoreHeroFeatures';
import { StoreHeroContext } from './StoreHero.context';
import { StoreHeroDropdown } from './modules/store-hero-dropdown/StoreHeroDropdown';
import styles from './store-hero.module.scss';

const cx = classNames.bind(styles);

const StoreHero = ({
  className, children, hideBackgroundImage, storeId
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-hero.ready'); }, []);

  const options = {
    variables: {
      storeSearchInput: storeId,
      pagesize: '1'
    }
  };

  const { data, loading } = useDataModel('storeSearch', options);
  const store = data?.storeSearch?.stores?.[0];
  const contextValue = {
    hideBackgroundImage,
    loading,
    store: {
      ...store,
      storeId: Number(storeId).toString()
    }
  };

  const storeHeroClasses = cx(className, 'store-hero', {
    'store-hero--with-background': !hideBackgroundImage
  });

  return (
    <StoreHeroContext.Provider value={contextValue}>
      <div className={storeHeroClasses}>
        {children}
      </div>
    </StoreHeroContext.Provider>
  );
};

StoreHero.propTypes = {
  className: string,
  hideBackgroundImage: bool,
  storeId: string.isRequired,
  children: node.isRequired
};

StoreHero.defaultProps = {
  className: null,
  hideBackgroundImage: false
};

StoreHero.displayName = 'StoreHero';

StoreHero.dataModel = extend({},
  StoreHeroFeatures,
  StoreLayout,
  StorePod,
  StoreHeroDropdown
);

export { StoreHero };
